import { Routes, Route, Navigate } from 'react-router-dom';
import { useSettings } from './lib/store';
import SplashScreen from './routes/SplashScreen';
import HomeScreen from './routes/HomeScreen';
import ScanScreen from './routes/ScanScreen';
import MenuScreen from './routes/MenuScreen';
import OrderScreen from './routes/OrderScreen';
import MeScreen from './routes/MeScreen';
import FAQScreen from './routes/FAQScreen';
import SafetyScreen from './routes/SafetyScreen';
import SafetyConditionScreen from './routes/SafetyConditionScreen';

export default function App() {
  const onboarded = useSettings((s) => s.hasCompletedOnboarding);

  return (
    <Routes>
      <Route path="/" element={onboarded ? <HomeScreen /> : <Navigate to="/welcome" replace />} />
      <Route path="/welcome" element={<SplashScreen />} />
      <Route path="/scan" element={<ScanScreen />} />
      <Route path="/menu/:menuId" element={<MenuScreen />} />
      <Route path="/menu/:menuId/order" element={<OrderScreen />} />
      <Route path="/orders/:orderId" element={<OrderScreen />} />
      <Route path="/me" element={<MeScreen />} />
      {/* Legacy paths — kept as redirects for any bookmarks/share-links. */}
      <Route path="/me/saved" element={<Navigate to="/me" replace />} />
      <Route path="/settings" element={<Navigate to="/me" replace />} />
      <Route path="/faq" element={<FAQScreen />} />
      <Route path="/safety" element={<SafetyScreen />} />
      <Route path="/safety/:condition" element={<SafetyConditionScreen />} />
      <Route path="*" element={<Navigate to="/" replace />} />
    </Routes>
  );
}
